import strings from "../../i18n/definitions";
import * as s from "./Exercise.sc";
import { toast } from "react-toastify";
import useScreenWidth from "../../hooks/useScreenWidth";
import DisableAudioSession from "./DisableAudioSession";
import { EXERCISE_TYPES } from "../ExerciseTypeConstants";
import SessionStorage from "../../assorted/SessionStorage";
import FlagOutlinedIcon from "@mui/icons-material/FlagOutlined";
import ExplainWordButton from "./ExplainWordButton";

export default function SolutionFeedbackLinks({
  exerciseBookmarks,
  exerciseBookmark,
  handleShowSolution,
  isExerciseOver,
  shareableUrl,
  exerciseType,
  disableAudio,
  setIsExerciseOver,
  onWordRemovedFromExercises,
  onReportClick,
  isReported,
}) {
  const { isMobile } = useScreenWidth();

  function handleIKnowThisWord() {
    if (onWordRemovedFromExercises && exerciseBookmark) {
      onWordRemovedFromExercises("i_know_this", exerciseBookmark.user_word_id);
      toast.success(`"${exerciseBookmark.from}" removed from practice`);
    }
  }

  return (
    <>
      <s.CenteredWordRow
        className={!isExerciseOver ? "margin-top-auto" : ""}
        style={{
          flexDirection: isMobile ? "column" : "row",
          marginTop: !isExerciseOver ? "1rem" : "0",
          gap: "1rem",
          marginBottom: isMobile ? "2rem" : "1rem",
        }}
      >
        {!isExerciseOver && (
          <>
            <s.StyledGreyButton className="styledGreyButton" onClick={handleShowSolution}>
              {strings.showSolution}
            </s.StyledGreyButton>
            {EXERCISE_TYPES.isAudioExercise(exerciseType) && SessionStorage.isAudioExercisesEnabled() && (
              <DisableAudioSession handleDisabledAudio={disableAudio} setIsCorrect={setIsExerciseOver} />
            )}
          </>
        )}
      </s.CenteredWordRow>

      {isExerciseOver && (
        <s.CenteredWordRow style={{ gap: "1em", flexWrap: "wrap", marginBottom: isMobile ? "2rem" : "1rem" }}>
          {/* Hide "I know this word" only for Match, where multiple words are practiced at once */}
          {exerciseType !== EXERCISE_TYPES.match && (
            <s.StyledGreyButton className="styledGreyButton" onClick={handleIKnowThisWord}>
              {strings.iKnowThisWord}
            </s.StyledGreyButton>
          )}
          {exerciseType !== EXERCISE_TYPES.match && <ExplainWordButton bookmark={exerciseBookmark} />}
          {shareableUrl && (
            <s.StyledGreyButton
              className="styledGreyButton"
              onClick={() => {
                navigator.clipboard
                  .writeText(shareableUrl)
                  .then(() => {
                    toast.success("Exercise link copied to clipboard!");
                  })
                  .catch((err) => {
                    toast.error("Failed to copy link to clipboard");
                  });
              }}
            >
              Share exercise
            </s.StyledGreyButton>
          )}
        </s.CenteredWordRow>
      )}

      {onReportClick && (
        <s.CenteredWordRow style={{ marginBottom: isMobile ? "1rem" : "0.5rem" }}>
          {isReported ? (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                color: "#999",
                fontSize: "0.75rem",
                gap: "0.25rem",
              }}
            >
              <FlagOutlinedIcon fontSize="small" />
              Reported
            </div>
          ) : (
            <button
              onClick={onReportClick}
              title="Report issue with this exercise"
              aria-label="Report issue with this exercise"
              style={{
                background: "none",
                border: "none",
                padding: "0.25rem",
                cursor: "pointer",
                color: "grey",
                display: "flex",
                alignItems: "center",
                gap: "0.25rem",
                fontSize: "0.75rem",
                opacity: 0.7,
              }}
            >
              <FlagOutlinedIcon fontSize="small" />
              Report
            </button>
          )}
        </s.CenteredWordRow>
      )}
    </>
  );
}
